import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentFeedbackRoutingModule } from './student-feedback-routing.module';
import { StudentFeedbackReportComponent } from './student-feedback-report/student-feedback-report.component';
import { StudentFeedbackLinkComponent } from './student-feedback-link/student-feedback-link.component';
import { StudentFeedbackDialogComponent } from './student-feedback-dialog/student-feedback-dialog.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    StudentFeedbackReportComponent,
    StudentFeedbackLinkComponent,
    StudentFeedbackDialogComponent
  ],
  imports: [
    CommonModule,
    StudentFeedbackRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class StudentFeedbackModule { }
